import classNames from 'classnames';
import React from 'react';

import styles from './Link.module.scss';

export enum LinkTypeEnum {
    OFFER = 'offer',
    PRIMARY = 'primary',
    NEUTRAL = 'neutral',
}

export interface LinkProps extends React.HTMLProps<HTMLAnchorElement> {
    linkType?: LinkTypeEnum;
    bold?: boolean;
    withPadding?: boolean;
    ellipsis?: boolean;
    noWrap?: boolean;
    heading?: boolean;
    dataZta?: string;
}

const Link: React.FC<LinkProps> = ({
    children,
    bold = true,
    heading,
    ellipsis,
    noWrap,
    linkType = LinkTypeEnum.PRIMARY,
    withPadding = true,
    href,
    dataZta,
    className,
    ...props
}) => {
    return (
        <a
            href={href}
            data-zta={dataZta}
            data-link-type={linkType}
            className={classNames(className, styles.link, {
                [styles.linkPadding]: withPadding,
                [styles.linkNoWrap]: noWrap,
                [styles.linkEllipsis]: ellipsis,
                [styles.linkBold]: bold,
                [styles.linkHeading]: heading,
                [styles.linkPrimary]: linkType === LinkTypeEnum.PRIMARY,
                [styles.linkOffer]: linkType === LinkTypeEnum.OFFER,
                [styles.linkNeutral]: linkType === LinkTypeEnum.NEUTRAL,
            })}
            {...props}>
            {children}
        </a>
    );
};

export default Link;
